import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'

import './styles/index.scss'

import IndexRoute from './routes/index.routes'
import NotificationProvider from '@ui/notification/notification.provider'
import ErrorBoundary from '@primitive/errorBoundary'
import { installGlobalClientErrorHandlers } from '@services/client-error.service'

installGlobalClientErrorHandlers()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <ErrorBoundary>
        <ConfigProvider
            theme={{
                token: {
                    fontFamily: 'SF Pro Text, sans-serif'
                }
            }}
        >
            <BrowserRouter>
                <NotificationProvider>
                    <IndexRoute />
                </NotificationProvider>
            </BrowserRouter>
        </ConfigProvider>
    </ErrorBoundary>
)